<template>
    <div v-if="isValid('CanViewBalanceSheetReport')" v-bind:style="$i18n.locale == 'ar' ? languageChange('en') : languageChange('ar')">
        <div  v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="col-md-6 col-lg-6">
                            <h5 class="ml-3 DayHeading">{{ $t('BalanceSheetReport.BalanceSheetReport') }}</h5>
                        </div>
                        <div class="col-md-6 col-lg-6" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-right' : 'text-left'">

                            <router-link :to="'/AllReports'">
                                <a href="javascript:void(0)" class="btn btn-outline-primary  "><i class="fas fa-arrow-circle-left fa-lg"></i> </a>
                            </router-link>
                            <a href="javascript:void(0)" class="btn btn-outline-primary" v-on:click="PrintCsv">Export CSV</a>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="col-lg-12">
                        <div class="row">
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label>{{ $t('BalanceSheetReport.FromDate') }}</label>
                                    <datepicker v-model="fromDate" :key="rander" />
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label>{{ $t('BalanceSheetReport.ToDate') }}</label>
                                    <datepicker v-model="toDate" :key="rander" />
                                </div>
                            </div>

                        </div>
                        <br />
                        <div class="table  ">
                            <table class="table table-striped table-hover">
                                <thead>
                                    <tr><h4>{{$t('BalanceSheetReport.Assets')}}</h4></tr>
                                    <tr class="table_list_bg">
                                        <th style="width: 20%">#</th>
                                        <th style="width: 20%">{{ $t('BalanceSheetReport.Code') }}</th>
                                        <th style="width: 30%">{{ $t('BalanceSheetReport.Account') }}</th>
                                        <th>{{$t('BalanceSheetReport.Amount')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(asset,index) in assets" v-bind:key="asset.Id">
                                        <td>{{index+1}}</td>
                                        <td>{{asset.code}}</td>
                                        <td>
                                            <span v-if="language=='en'">{{asset.costCenter}}</span>
                                            <span v-else>{{asset.costCenterArabic}}</span>
                                        </td>
                                        <td>
                                            <span v-if="asset.amount < 0" :class="'text-danger'">({{Number(Math.abs(parseFloat(asset.amount).toFixed(2))).toLocaleString()}})</span>
                                            <span v-else>{{Number(Math.abs(parseFloat(asset.amount).toFixed(2))).toLocaleString()}}</span>
                                        </td>
                                        <hr />
                                    </tr>
                                    <tr>
                                        <td></td><td></td>
                                        <td><b>{{ $t('BalanceSheetReport.Total') }}</b></td>
                                        <td><b>
                                            <span v-if="totalAssets < 0" :class="'text-danger'">({{Number(Math.abs(parseFloat(totalAssets).toFixed(2))).toLocaleString()}})</span>
                                            <span v-else>{{Number(Math.abs(parseFloat(totalAssets).toFixed(2))).toLocaleString()}}</span>
                                        </b></td>
                                    </tr>
                                </tbody>
                                <thead>
                                    <tr>
                                        <h4>{{$t('BalanceSheetReport.Liabilities')}}</h4>
                                    </tr>

                                </thead>
                                <tbody>
                                    <tr v-for="(liability,index) in liabilities" v-bind:key="liability.Id">
                                        <td>{{index+1}}</td>
                                        <td>{{liability.code}}</td>
                                        <td>
                                            <span v-if="language=='en'">{{liability.costCenter}}</span>
                                            <span v-else>{{liability.costCenterArabic}}</span>
                                        </td>
                                        <td>
                                            <span v-if="liability.amount < 0" :class="'text-danger'">({{Number(Math.abs(parseFloat(liability.amount).toFixed(2))).toLocaleString()}})</span>
                                            <span v-else>{{Number(Math.abs(parseFloat(liability.amount).toFixed(2))).toLocaleString()}}</span>
                                        </td>
                                        <hr />
                                    </tr>

                                    <tr>
                                        <td></td><td></td>
                                        <td><b>{{ $t('BalanceSheetReport.Total') }}</b></td>
                                        <td><b>
                                            <span v-if="totalLiabilities < 0" :class="'text-danger'">({{Number(Math.abs(parseFloat(totalLiabilities).toFixed(2))).toLocaleString()}})</span>
                                            <span v-else>{{Number(Math.abs(parseFloat(totalLiabilities).toFixed(2))).toLocaleString()}}</span>
                                        </b></td>
                                    </tr>
                                </tbody>
                                <thead>
                                    <tr><h4>{{$t('BalanceSheetReport.Equity')}}</h4></tr>

                                </thead>
                                <tbody>

                                    <tr v-for="(equity,index) in equity" v-bind:key="equity.Id">
                                        <td>{{index+1}}</td>
                                        <td>{{equity.code}}</td>
                                        <td>
                                            <span v-if="language=='en'">{{equity.costCenter}}</span>
                                            <span v-else>{{equity.costCenterArabic}}</span>
                                        </td>
                                        <td>
                                            <span v-if="equity.amount < 0" :class="'text-danger'">({{Number(Math.abs(parseFloat(equity.amount).toFixed(2))).toLocaleString()}})</span>
                                            <span v-else>{{Number(Math.abs(parseFloat(equity.amount).toFixed(2))).toLocaleString()}}</span>
                                        </td>
                                        <hr />
                                    </tr>
                                    <tr>
                                        <td>
                                        </td>
                                        <td>
                                        </td>
                                        <td>
                                            Current Year Earnings
                                        </td>
                                        <td>
                                            <span v-if="NetIncome < 0" :class="'text-danger'">({{Number(Math.abs(parseFloat(NetIncome).toFixed(2))).toLocaleString()}})</span>
                                            <span v-else>{{Number(Math.abs(parseFloat(NetIncome).toFixed(2))).toLocaleString()}}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td><b>{{ $t('BalanceSheetReport.Total') }}</b></td>
                                        <td><b>
                                            <span v-if="totalEquity < 0" :class="'text-danger'">({{Number(Math.abs(parseFloat(totalEquity).toFixed(2))).toLocaleString()}})</span>
                                            <span v-else>{{Number(Math.abs(parseFloat(totalEquity).toFixed(2))).toLocaleString()}}</span>
                                        </b></td>
                                    </tr>
                                    <br />
                                    <br />
                                    <tr>
                                        <td><b>{{ $t('BalanceSheetReport.Total')}} {{ $t('BalanceSheetReport.EquityandLiabilities') }}</b></td>
                                        <td>
                                            <b>{{Number(Math.abs(parseFloat(totalEquityLiability).toFixed(2))).toLocaleString()}}</b>
</td>
                                        <td><b>{{ $t('BalanceSheetReport.Total') }} {{ $t('BalanceSheetReport.Assets') }}</b></td>
                                        <td>
                                            <b><span>{{Number(Math.abs(parseFloat(totalAssets).toFixed(2))).toLocaleString()}}</span></b>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else> <acessdenied></acessdenied></div>
</template>
<script>
    import clickMixin from '@/Mixins/clickMixin'


    import moment from "moment";
    export default {
        mixins: [clickMixin],
        data: function () {
            return {
                date:'',
                fromDate: '',
                toDate: '',
                rander: 0,
                printRender: 0,
                currentPage: 1,
                pageCount: '',
                rowCount: '',
                isShown: false,
                assets: [],
                liabilities: [],
                equity: [],
                records: [],
                advanceFilters: false,
                combineDate: '',
                language: 'Nothing',
                totalAssets:0,
                totalLiabilities: 0,
                totalEquity: 0,
                totalEquityLiability: 0,
                totalIncome: 0,
                totalExpense: 0,
                NetIncome: 0,
                isNegative: false,
               



            }
        },
        watch: {
            toDate: function (todate) {
                var fromdate = this.fromDate;

                this.GetInventoryList(fromdate, todate);
            },
            fromDate: function (fromdate) {
                var todate = this.toDate;

                this.GetInventoryList(fromdate, todate);

            }
        },
        methods: {
            PrintCsv: function () {
                
                var root = this;
                root.$https.get('/Report/BalanceSheetCsv?language=' + this.$i18n.locale + '&fromDate=' + this.fromDate + '&toDate=' + this.toDate  + '&companyId=' + localStorage.getItem('CompanyID'), { headers: { "Authorization": `Bearer ${localStorage.getItem('token')}` }, responseType: 'blob' })
                    .then(function (response) {
                        
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                     
                            link.setAttribute('download', 'BalanceSheetReport.csv');

                     
                        document.body.appendChild(link);
                        link.click();

                    });
            },

            languageChange: function (lan) {
                if (this.language == lan) {

                    var getLocale = this.$i18n.locale;
                    this.language = getLocale;

                    this.$router.go('/BalanceSheetReport');

                }
            },
            convertDate: function (date) {
                return moment(date).format('l');
            },
            getPage: function () {
                this.GetInventoryList(this.fromDate, this.toDate, this.currentPage);
            },

            GetInventoryList: function (fromdate, todate) {
                
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                this.$https.get('/Report/BalanceSheet?fromDate=' + fromdate + '&toDate=' + todate, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null) {
                            root.records = response.data;
                            root.assets = response.data.asset;
                            
                            root.totalAssets = root.assets.reduce(function (prev, item) {
                                return prev + Number(item.amount);
                            }, 0);
                            

                            root.liabilities = response.data.liability;
                          
                            root.totalLiabilities = root.liabilities.reduce(function (prev, item) {
                                return (prev + Number(item.amount));
                            }, 0);
                            

                            root.NetIncome = response.data.yearlyIncome;

                            root.equity = response.data.equity;

                            root.totalEquity = root.NetIncome + (root.equity.reduce(function (prev, item) {
                                return (prev + Number(item.amount));

                            }, 0)) ;
                           

                            root.totalEquityLiability = root.totalEquity + root.totalLiabilities
                           

                            
                            
                        }
                            
                    });     
               

            },

            PrintDetails: function () {
                var root = this;
                root.isShown = true;
                root.combineDate = 'From Date: ' + this.fromDate + ' To Date: ' + this.toDate;
                root.printRender++;
            }
        },
        mounted: function () {
            this.language = this.$i18n.locale;
            this.fromDate = moment().subtract(15, 'days').format("DD MMM YYYY");
            this.toDate = moment().format("DD MMM YYYY");
            this.rander++;
        }
    }
</script>